import React from "react";
import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import "./Styling.css";

const QuestionType = ({ insights }) => {
  const data = [
    {
      name: "User Typed Questions",
      value: insights?.user_typed_questions || 0,
    },
    {
      name: "Cached Questions",
      value: insights?.user_cached_questions || 0,
    },
    {
      name: "Suggested Questions",
      value: insights?.user_suggested_questions || 0,
    },
  ];
  const colors = ["#eb5f1a", "#f6a417", "#438ac9"];

  return (
    <div className="chart-container">
      <h3 className="chart-title">Question Type Distribution</h3>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={100}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colors[index]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend layout="vertical"  />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default QuestionType;
